/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bulb-unit-chip',
  templateUrl: './unit-chip.component.html',
  styleUrls: ['./unit-chip.component.scss'],
  standalone: false,
})
export class UnitChipComponent implements OnInit {
  @Input() unit: any;

  public isInherited: boolean;

  ngOnInit(): void {
    // Some APIs may return a string value instead of a boolean.
    if (typeof this.unit.inherited === 'string') {
      this.isInherited = this.unit.inherited === 'true';
    } else {
      this.isInherited = this.unit.inherited;
    }
  }
}
